import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Invoices } from '../components/invoicing/Invoices';
import { DeliveryNotes } from '../components/invoicing/DeliveryNotes';

export const Invoicing = () => {
  const { t, language } = useLanguage();

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="invoicing-title">
        {t('invoicing')}
      </h1>

      <Tabs defaultValue="invoices" className="w-full">
        <TabsList className="mb-6">
          <TabsTrigger value="invoices" data-testid="tab-invoices">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('invoices')}</span>
          </TabsTrigger>
          <TabsTrigger value="delivery-notes" data-testid="tab-delivery-notes">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('deliveryNotes')}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="invoices">
          <Invoices />
        </TabsContent>
        <TabsContent value="delivery-notes">
          <DeliveryNotes />
        </TabsContent>
      </Tabs>
    </div>
  );
};